import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, computed, withDefaults } from "vue";

import { defineComponent, ref } from "vue";
import InputSwitch from "primevue/inputswitch";

const __default__ = defineComponent({
  name: "VZSwitchButton",
  inheritAttrs: false,
  components: {
    InputSwitch,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const dynamicAttrs = computed(() => {
  const clonedAttrs = { ...attrs };
  // Check if attrs.style.defaultFonts is "true !important"
  if (
    clonedAttrs.style &&
    clonedAttrs.style.defaultBorder === "true !important"
  ) {
    clonedAttrs.style.borderColor = "";
    clonedAttrs.style.borderWidth = "";
    clonedAttrs.style.borderStyle = "";
    clonedAttrs.style.padding = "";
    clonedAttrs.style.margin = "";
    clonedAttrs.borderColor = "";
    clonedAttrs.borderWidth = "";
    clonedAttrs.borderStyle = "";
    clonedAttrs.padding = "";
    clonedAttrs.margin = "";
  }

  return clonedAttrs;
});
const checked = ref(false);
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "VZ_TABLE_BUTTON" }, _unref(dynamicAttrs)), [
    _createVNode(_unref(InputSwitch), {
      name: _unref(attrs).name,
      modelValue: checked.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checked).value = $event)),
      style: _normalizeStyle(_unref(style))
    }, null, 8, ["name", "modelValue", "style"])
  ], 16))
}
}

})